var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayertableicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22_copy_2",
    "data-name": "Group 22 copy 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #749f18;\r\n        stroke: #fff;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7669,327.412h7.39V330l7.61-5-7.61-5v2.589H7669v4.824Z",
    transform: "translate(-7666 -317)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7688,333l3-2.631h-2.26V319.635H7691L7688,317l-3,2.632h2.27v10.732H7685Z",
    transform: "translate(-7666 -317)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayertableicon3);
export default __webpack_public_path__ + "static/media/playertable icon-3.7875ea03aa1e88da4b18ea5611110001.svg";
export { ForwardRef as ReactComponent };